"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
function RevRenameImage(props) {
  var schema = props.schema,
    uiSchema = props.uiSchema,
    formData = props.formData;
  if (typeof uiSchema.hidden === 'undefined') {
    return null;
  }
  if (uiSchema.hidden) {
    return null;
  }
  return react_1.default.createElement("div", {
    style: {
      margin: '10px 0',
      maxWidth: 800
    }
  }, react_1.default.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, schema.title), react_1.default.createElement(antd_1.Input, {
    disabled: true,
    value: formData
  }));
}
exports.default = RevRenameImage;